import { api, providesList } from "api/baseApi";
import qs from "query-string";
import { InvoiceName, InvoiceNameForm } from "pages/invoice-name/types";

const url = "/invoice-name";

export const { useGetInvoiceNamesQuery, useCreateInvoiceNameMutation, useUpdateInvoiceNameMutation, useDeleteInvoiceNameMutation, useImportInvoiceNamesMutation } = api.injectEndpoints({
	endpoints: (build) => ({
		getInvoiceNames: build.query<ResponsePaginated<InvoiceName>, Record<string, any>>({
			query: (query) => `${url}?${qs.stringify(query)}`,
			providesTags: (result) => providesList(result?.items, "invoice-name"),
		}),

		createInvoiceName: build.mutation<InvoiceName, InvoiceNameForm>({
			query: (body) => ({
				url,
				method: "POST",
				body,
			}),
			invalidatesTags: (_, error) => (error ? [] : [{ type: "invoice-name", id: "LIST" }]),
		}),

		updateInvoiceName: build.mutation<InvoiceName, InvoiceNameForm & { id: number }>({
			query: ({ id, ...body }) => ({
				url: `${url}/${id}`,
				method: "PUT",
				body,
			}),
			invalidatesTags: (_, error, { id }) =>
				error
					? []
					: [
							{ type: "invoice-name", id },
							{ type: "invoice-name", id: "LIST" },
						],
		}),

		deleteInvoiceName: build.mutation<void, number>({
			query: (id) => ({
				url: `${url}/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: (_, error, id) =>
				error
					? []
					: [
							{ type: "invoice-name", id },
							{ type: "invoice-name", id: "LIST" },
						],
		}),

		importInvoiceNames: build.mutation<{ success: number; failed: string[] }, InvoiceNameForm[]>({
			query: (body) => ({
				url: `${url}/import`,
				method: "POST",
				body,
			}),
			invalidatesTags: (_, error) => (error ? [] : [{ type: "invoice-name", id: "LIST" }]),
		}),
	}),
});
